<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/hrdata/personal' }">人资系统</el-breadcrumb-item>
        <el-breadcrumb-item>个人中心</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-row v-if="tabName == null">
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="$router.push('/workflow/application')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #67c23a;">
              <CirclePlus />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>系统业务申请</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="pageChange('个人考勤')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #e6a23c;">
              <Search />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>个人考勤查询</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="pageChange('月度薪资')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #f56c6c;">
              <Money />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>月度薪资</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="pageChange('个人资料')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(194, 0, 232);">
              <DocumentChecked />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>个人资料</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="pageChange('安全密码')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #409eff;">
              <Lock />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>安全密码管理</p>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-descriptions v-if="tabName == '月度薪资'" title="个人月度薪资查询(查询上个月)" direction="horizontal" border :column="1"
      label-width="120px" style="margin-top: 0px">
      <el-descriptions-item label="月份" label-align="right">
        <el-date-picker v-model="month" type="month" placeholder="年月" @change="pageChange()"
          style="max-width: 180px;" />
      </el-descriptions-item>
      <el-descriptions-item label="姓名" label-align="right">
        <template #label>
          <div class="cell-item">
            <el-icon>
              <user />
            </el-icon>
            姓名
          </div>
        </template>
        {{ salary.employeeName }}
      </el-descriptions-item>
      <el-descriptions-item label="公司" label-align="right">{{ salary.companyName }}</el-descriptions-item>
      <el-descriptions-item label="部门" label-align="right">{{ salary.departmentName }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item label="基础工资" label-align="right">{{ salary.basicSalaryFee }}</el-descriptions-item>
      <el-descriptions-item label="岗位工资" label-align="right">{{ salary.basicPositionFee }}</el-descriptions-item>
      <el-descriptions-item label="绩效工资" label-align="right">{{ salary.basicPerformanceFee }}</el-descriptions-item>
      <el-descriptions-item label="保密费" label-align="right">{{ salary.basicConfidentialFee }}</el-descriptions-item>
      <el-descriptions-item label="津补贴" label-align="right">{{ salary.basicAllowanceFee }}</el-descriptions-item>
      <el-descriptions-item label="基础工资合计" label-align="right">{{ salary.basicTotalFee }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item label="绩效奖金" label-align="right">{{ salary.otherBonusFee }}</el-descriptions-item>
      <el-descriptions-item label="其他收入" label-align="right">{{ salary.otherIncomeFee }}</el-descriptions-item>
      <el-descriptions-item label="加班费" label-align="right">{{ salary.overtimeFee }}</el-descriptions-item>
      <el-descriptions-item label="实发提成" label-align="right">{{ salary.commissionFee }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item label="行政缺勤小时数" label-align="right">{{ salary.absenceHours }}</el-descriptions-item>
      <el-descriptions-item label="考勤扣款" label-align="right">{{ salary.attendanceDeductionFee }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item label="其他补贴" label-align="right">{{ salary.otherAllowanceFee }}</el-descriptions-item>
      <el-descriptions-item label="其他扣款" label-align="right">{{ salary.otherDeductionFee }}</el-descriptions-item>
      <el-descriptions-item label="其他代扣款" label-align="right">{{ salary.withholdingFee }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item label="应发工资" label-align="right">{{ salary.grossSalaryFee }}</el-descriptions-item>
      <el-descriptions-item label="个人社保" label-align="right">{{ salary.personalSocialSecurityFee
      }}</el-descriptions-item>
      <el-descriptions-item label="个人住房公积金" label-align="right">{{ salary.personalHousingFundFee
      }}</el-descriptions-item>
      <el-descriptions-item label="纳税所得额" label-align="right">{{ salary.taxableIncomeFee }}</el-descriptions-item>
      <el-descriptions-item label="专项扣除" label-align="right">{{ salary.specialDeductionFee }}</el-descriptions-item>
      <el-descriptions-item label="个人所得税" label-align="right">{{ salary.incomeTaxFee }}</el-descriptions-item>
      <el-descriptions-item label="实发工资" label-align="right">{{ salary.netSalaryFee }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <!-- <el-descriptions-item label="对公报销" label-align="right">{{ salary.reimbursementFee }}</el-descriptions-item> -->
      <!-- <el-descriptions-item label="其他发放" label-align="right">{{ salary.privatePaymentFee }}</el-descriptions-item> -->

    </el-descriptions>

    <el-descriptions v-if="tabName == '个人考勤'" title="个人考勤查询" direction="horizontal" border :column="1"
      label-width="120px" style="margin-top: 20px">
      <el-descriptions-item label="月份" label-align="right">
        <el-date-picker v-model="month" type="month" placeholder="年月" @change="pageChange()"
          style="max-width: 180px;" />
      </el-descriptions-item>
      <!-- <el-descriptions-item label="姓名" label-align="right">
        <template #label>
          <div class="cell-item">
            <el-icon>
              <user />
            </el-icon>
            姓名
          </div>
        </template>
        {{ signDaily.姓名 }}
      </el-descriptions-item> -->
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item v-for="(value, key) in signDaily" :label="key" label-align="right">
        {{ value }}
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions v-if="tabName == '个人资料'" title="个人资料" direction="horizontal" border :column="1" label-width="120px"
      style="margin-top: 20px">
      <!-- <el-descriptions-item v-for="(value,key) in person" :label="key" label-align="right" >
        {{ value }}
      </el-descriptions-item> -->

      <el-descriptions-item label="公司" label-align="right">{{ person.companyName }}</el-descriptions-item>
      <el-descriptions-item label="部门" label-align="right">{{ person.departmentName }}</el-descriptions-item>
      <el-descriptions-item label="姓名" label-align="right">{{ person.realName }}</el-descriptions-item>
      <el-descriptions-item label="性别" label-align="right">{{ person.gender }}</el-descriptions-item>
      <el-descriptions-item label="角色权限" label-align="right">{{ person.roles }}</el-descriptions-item>

    </el-descriptions>

    <!-- 安全密码管理 -->
    <div v-if="tabName == '安全密码'" style="margin-top: 20px;">
      <el-card shadow="never">
        <template #header>
          <div style="display: flex; align-items: center;">
            <el-icon style="margin-right: 8px;">
              <Lock />
            </el-icon>
            <span>安全密码管理</span>
          </div>
        </template>

        <el-alert v-if="!hasSecondaryPassword" title="您尚未设置安全密码" type="warning"
          description="安全密码用于查询考勤和薪资等敏感信息时的二次验证，请妥善保管。密码长度不能少于6位。" :closable="false" show-icon
          style="margin-bottom: 20px;">
        </el-alert>

        <el-alert v-else title="已设置安全密码" type="success" description="您已设置安全密码，可以通过重置功能修改密码。" :closable="false" show-icon
          style="margin-bottom: 20px;">
        </el-alert>

        <!-- 设置密码表单（未设置时显示） -->
        <el-form v-if="!hasSecondaryPassword" ref="setPasswordFormRef" :model="setPasswordForm"
          :rules="setPasswordRules" label-width="120px" style="max-width: 500px;">
          <el-form-item label="新密码" prop="password">
            <el-input v-model="setPasswordForm.password" type="password" show-password autocomplete="new-password"
              placeholder="请输入安全密码（不少于6位）" clearable />
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input v-model="setPasswordForm.confirmPassword" type="password" show-password
              autocomplete="new-password" placeholder="请再次输入安全密码" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSetPassword" :loading="submitting">
              设置安全密码
            </el-button>
          </el-form-item>
        </el-form>

        <!-- 重置密码表单（已设置时显示） -->
        <el-form v-else ref="resetPasswordFormRef" :model="resetPasswordForm" :rules="resetPasswordRules"
          label-width="120px" style="max-width: 500px;">
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input v-model="resetPasswordForm.oldPassword" type="password" show-password autocomplete="off"
              placeholder="请输入当前安全密码" clearable />
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input v-model="resetPasswordForm.newPassword" type="password" show-password autocomplete="new-password"
              placeholder="请输入新安全密码（不少于6位）" clearable />
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmNewPassword">
            <el-input v-model="resetPasswordForm.confirmNewPassword" type="password" show-password
              autocomplete="new-password" placeholder="请再次输入新安全密码" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleResetPassword" :loading="submitting">
              重置安全密码
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <el-button icon="Back" type="primary" v-if="tabName != null" @click="tabName = null"
      style="margin-top:20px; margin-left: 10px; position:absolute; bottom: 30px;">
      返 回
    </el-button>

    <!-- 二次密码验证对话框 -->
    <el-dialog v-model="secondaryPasswordDialog" title="安全验证" width="400px" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="true" @close="handleSecondaryPasswordCancel">
      <el-alert title="需要验证安全密码" type="info" :closable="false" show-icon style="margin-bottom: 20px;">
        <template #default>
          <div>查询敏感信息需要输入安全密码进行验证</div>
          <div style="margin-top: 5px; font-size: 12px; color: #909399;">验证成功后5分钟内无需重复输入</div>
        </template>
      </el-alert>

      <el-form ref="secondaryPasswordFormRef" :model="secondaryPasswordForm" :rules="secondaryPasswordFormRules">
        <el-form-item label="安全密码" prop="password">
          <el-input v-model="secondaryPasswordForm.password" type="password" show-password autocomplete="off"
            placeholder="请输入安全密码" clearable @keyup.enter="handleSecondaryPasswordSubmit" />
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleSecondaryPasswordCancel">取消</el-button>
          <el-button type="primary" @click="handleSecondaryPasswordSubmit" :loading="verifyingPassword">
            验证
          </el-button>
        </span>
      </template>
    </el-dialog>
  </el-card>

</template>

<script>
export default {
  name: "personal",
  components: {},
  data() {
    // 自定义验证器：确认密码
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.setPasswordForm.password) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };

    // 自定义验证器：确认新密码
    const validateConfirmNewPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.resetPasswordForm.newPassword) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };

    return {
      tabName: null,
      month: null,
      salary: {},
      signDaily: {},
      person: {},

      // 安全密码相关
      hasSecondaryPassword: false,
      submitting: false,

      // 二次密码验证
      secondaryPasswordDialog: false,
      verifyingPassword: false,
      tempSecondaryPassword: null,  // 临时存储的二次密码
      tempPasswordExpireTime: null, // 密码过期时间

      secondaryPasswordForm: {
        password: ''
      },
      secondaryPasswordFormRules: {
        password: [
          { required: true, message: '请输入安全密码', trigger: 'blur' }
        ]
      },

      // 设置密码表单
      setPasswordForm: {
        password: '',
        confirmPassword: ''
      },
      setPasswordRules: {
        password: [
          { required: true, message: '请输入安全密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },

      // 重置密码表单
      resetPasswordForm: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      resetPasswordRules: {
        oldPassword: [
          { required: true, message: '请输入当前安全密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新安全密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmNewPassword: [
          { required: true, validator: validateConfirmNewPassword, trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    if (this.$route.query.tabName)
      this.tabName = this.$route.query.tabName;

    const currentDate = new Date();
    if (currentDate.getDate() < 15) {
      //如果当前日期小于15号，则显示上个月
      this.month = new Date(currentDate.getFullYear(), currentDate.getMonth() - 2, currentDate.getDate());
    } else {
      //否则显示当前月
      this.month = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
    }

    // 检查是否已设置安全密码
    this.checkSecondaryPassword();
  },
  methods: {
    // 检查是否已设置安全密码
    async checkSecondaryPassword() {
      try {
        const res = await this.$kaung.fetch({
          url: '/BaseUser/HasSecondaryPassword',
          method: 'get'
        });
        if (res.code === 200 && res.data) {
          this.hasSecondaryPassword = res.data.hasSecondaryPassword || false;
        }
      } catch (error) {
        console.error('检查安全密码状态失败:', error);
      }
    },

    // 检查临时密码是否有效
    isSecondaryPasswordValid() {
      if (!this.tempSecondaryPassword || !this.tempPasswordExpireTime) {
        return false;
      }
      // 检查是否过期
      return new Date().getTime() < this.tempPasswordExpireTime;
    },

    // 清除临时密码
    clearTempSecondaryPassword() {
      this.tempSecondaryPassword = null;
      this.tempPasswordExpireTime = null;
    },

    // 显示二次密码验证对话框
    showSecondaryPasswordDialog() {
      this.secondaryPasswordDialog = true;
      this.secondaryPasswordForm.password = '';
    },

    // 提交二次密码验证
    handleSecondaryPasswordSubmit() {
      this.$refs.secondaryPasswordFormRef.validate((valid) => {
        if (!valid) return;

        const password = this.secondaryPasswordForm.password;

        // 使用MD5加密密码并临时保存
        this.tempSecondaryPassword = this.$util.md5Encrypt(password);
        // 设置5分钟后过期
        this.tempPasswordExpireTime = new Date().getTime() + 5 * 60 * 1000;

        // 关闭对话框
        this.secondaryPasswordDialog = false;
        this.secondaryPasswordForm.password = '';

        // 直接加载数据，如果密码错误会返回403
        this.loadHrSalaryData();
      });
    },

    // 取消二次密码验证
    handleSecondaryPasswordCancel() {
      this.secondaryPasswordDialog = false;
      this.secondaryPasswordForm.password = '';
      this.tabName = null;
    },

    // 加载敏感数据（薪资）
    loadHrSalaryData() {
      let year = this.month.getFullYear();
      let month = this.month.getMonth() + 1;

      this.salary = {};
      this.$kaung.fetch({
        url: `/HrSalary/Personal?year=${year}&month=${month}`,
        headers: {
          'X-Secondary-Password': this.tempSecondaryPassword
        }
      }).then((res) => {
        this.tabName = '月度薪资';
        if (res.code === 200) {
          this.salary = res.data || {};
          this.$message.success(res.content||'查询成功');
        } else {
          this.$message({ message: res.content, type: res.type });
        }
      }).catch((error) => {
        console.error('加载薪资数据失败:', error);
        // 捕获HTTP 403错误
        if (error && error.status === 403) {
          // 清除临时密码
          this.clearTempSecondaryPassword();
          this.$message.error('安全密码验证失败，请重新输入');
          // 重新显示验证对话框
          this.showSecondaryPasswordDialog();
        } else {
          this.$message.error('查询失败，请稍后重试');
        }
      });
    },

    // 设置安全密码
    handleSetPassword() {
      this.$refs.setPasswordFormRef.validate((valid) => {
        if (!valid) return;

        this.submitting = true;

        // 使用MD5加密密码
        const encryptedPassword = this.$util.md5Encrypt(this.setPasswordForm.password);

        const formData = new FormData();
        formData.append('secondaryPassword', encryptedPassword);

        this.$kaung.fetch({
          url: '/BaseUser/SetSecondaryPassword',
          method: 'post',
          data: formData
        }).then((res) => {
          this.$message({ message: res.content, type: res.type });
          if (res.code === 200) {
            // 重置表单
            this.setPasswordForm = {
              password: '',
              confirmPassword: ''
            };
            this.$refs.setPasswordFormRef.resetFields();
            // 重新检查状态
            this.checkSecondaryPassword();
          }
        }).finally(() => {
          this.submitting = false;
        });
      });
    },

    // 重置安全密码
    handleResetPassword() {
      this.$refs.resetPasswordFormRef.validate((valid) => {
        if (!valid) return;

        this.submitting = true;

        // 使用MD5加密旧密码和新密码
        const encryptedOldPassword = this.$util.md5Encrypt(this.resetPasswordForm.oldPassword);
        const encryptedNewPassword = this.$util.md5Encrypt(this.resetPasswordForm.newPassword);

        this.$kaung.fetch({
          url: '/BaseUser/ResetSecondaryPassword',
          method: 'get',
          params: {
            id: '',
            oldpassword: encryptedOldPassword,
            newpassword: encryptedNewPassword
          }
        }).then((res) => {
          this.$message({ message: res.content, type: res.type });
          if (res.code === 200) {
            // 重置表单
            this.resetPasswordForm = {
              oldPassword: '',
              newPassword: '',
              confirmNewPassword: ''
            };
            this.$refs.resetPasswordFormRef.resetFields();
          }
        }).finally(() => {
          this.submitting = false;
        });
      });
    },

    pageChange(tab) {
      tab = tab || this.tabName;
      if (tab) {
        this.tabName = tab;

        // 如果切换到安全密码页面，检查状态
        if (tab === '安全密码') {
          this.checkSecondaryPassword();
          return;
        }

        // 如果切换到月度薪资页面，需要二次验证
        if (tab === '月度薪资') {
          // 检查临时密码是否有效
          if (!this.isSecondaryPasswordValid()) {
            // 密码无效，显示验证对话框
            this.showSecondaryPasswordDialog();
            return;
          }
          // 密码有效，直接加载数据
          this.loadHrSalaryData();
          return;
        }

        // 如果切换到个人考勤页面，直接查询（不需要二次验证）
        if (tab === '个人考勤') {
          let year = this.month.getFullYear();
          let month = this.month.getMonth() + 1;
          this.signDaily = {};
          this.$kaung.fetch({ url: `/HrSignLog/SignMonthDaily?year=${year}&month=${month}&queryType=1` }).then((res) => {
            this.$message({ message: res.content, type: res.type });
            if (res.code === 200 && res.data.length == 1) {
              this.signDaily = res.data[0];
            }
          });
          return;
        }

        // 其他页面（个人资料）
        if (tab === '个人资料') {
          this.person = this.$store.getters.getUserInfo;
        }
      }
    },
  },
};
</script>
<style scoped>
.el-result {
  margin: 0 12px;
  border: 1px solid #fff;
  --el-result-padding: 20px;
  background: #fcfcfc;
}

.el-result:hover {
  border: 1px solid #ccc;
  border-radius: 10px;
  cursor: pointer;
}
</style>